import React from 'react';
import Grid from '@clasohlson/co-ui-components/Grid';
import Column from '@clasohlson/co-ui-components/Column';
import styled from 'styled-components';
// import { useTranslation } from 'react-i18next';
import { BorderedBox } from '../layout/BorderedBox';
import { getCountryCodeFromUrl, useTranslation } from '../../utils';

const StyledContactBox = styled(BorderedBox)`
  h4,
  .h4 {
    font-weight: 600;
  }
`;

const Title = styled.h4`
  font-family: 'Clas Ohlson Sans Web', 'Open Sans', 'Arial' !important;
  font-size: 21px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  margin: 11px 0 0 0;
  @media screen and (max-width: 600px) {
    font-size: 18px;
    line-height: 1.67;
  }
`;

const Description = styled.p`
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: center;
  color: #5f646a;
  @media screen and (max-width: 600px) {
    font-size: 13px;
  }
`;

const FillButton = styled.button`
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  letter-spacing: normal;
  border: 0;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.primary};
  color: #000;
  display: flex;
  text-transform: uppercase;
  flex-grow: 1;
  align-self: stretch;
  margin: 0;
  @media screen and (max-width: 600px) {
    font-size: 13px;
    border-radius: ${({ theme }) => theme.misc.buttonBorderRadius};
    height: 44px;
    line-height: 44px;
    margin: 0 1rem 1rem 1rem;
  }
`;

export const ContactBox = () => {
  const { t } = useTranslation();
  // const lang = i18n.language;
  const country = getCountryCodeFromUrl();
  return (
    <StyledContactBox>
      <Grid spacing="none">
        <Column lg="10" md="10" sm="10" xs="12">
          <Title>{t('contactTitle')}</Title>
          <Description>{t('contactDescription')}</Description>
        </Column>
        <Column lg="2" md="2" sm="2" xs="12">
          <FillButton
            onClick={() =>
              (window.location.href = `https://www.clasohlson.com/${country}/contact-us`)
            }
          >
            {t('contactBtn')}
          </FillButton>
        </Column>
      </Grid>
    </StyledContactBox>
  );
};
